import React, { useEffect, useRef, useState } from 'react';

import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

import { Print } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';

import attendanceServices from '../attendanceServices';
import DateSelect from '../../../../../components/AppInput/DateSelect';
import AppLayout from '../../../../../layout/components/AppLayout';
import { useAppData } from '../../../../../context/AppDataContext';

function AllWorkReportList() {
  const { employeeDD, getMasterLabel, getDDDataById } = useAppData();
  const [filter, setFilter] = useState(null);
  const [workReportList, setWorkReportList] = useState(null);
  const gridRef = useRef();

  // Full-screen Dialog state
  const [open, setOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const handleOpenImage = (url) => {
    setSelectedImage(url);
    setOpen(true);
  };

  const handleCloseImage = () => {
    setOpen(false);
    setSelectedImage(null);
  };

  const getWorkReport = () => {
    attendanceServices.getWorkReportListAll(filter).then(res => {
      setWorkReportList(res.data);
    }).catch(error => {
      console.log(error);
    });
  };

  const [defaultColDef] = useState({
    floatingFilter: true,
    filterParams: {
      buttons: ['apply'],
    },
    resizable: true,
    width: 120,
    filter: true,
    sortable: true,
    cellStyle: { 'textTransform': 'uppercase' },
  });

  const [columnDefs, setColumnDef] = useState();

  const prepairColumnDef = () => {
    let _columnDefs = [
      { field: "id", headerName: "ID" },
      { 
        headerName: "E. Name", 
        width: 150,
        valueGetter: params => {
          return getDDDataById(employeeDD, params.data.employeeId)?.label || '';
        }
      },
      { 
        headerName: "Image", 
        width: 220, 
        cellRenderer: (params) => {
          const imageUrl = params.data.imageUrl;

          // Check if imageUrl is null, undefined, or an empty string
          if (!imageUrl || imageUrl.trim() === "") {
            return null; // Renders an empty cell cleanly
          }

          return (
            <div 
              style={{ display: 'flex', alignItems: 'center', height: '100%', cursor: 'pointer' }}
              onClick={() => params.context.openImageDialog(imageUrl)}
            >
              <img 
                style={{ width: 200, height: 200, objectFit: 'cover', borderRadius: '4px' }} 
                src={imageUrl} 
                alt="Work Report"
              />
            </div>
          );
        }
      },
      { field: "report", headerName: "report", width: 800 },
      { field: "updated_at", headerName: "Date", width: 200 },
    ];
    setColumnDef(_columnDefs);
  };

  const onBtnExport = () => {
    gridRef.current.api.exportDataAsCsv("data.csv");
  };

    useEffect(() => {
    getWorkReport();
  }, [filter]);

  useEffect(() => {    
    prepairColumnDef();
  }, []);

  // Pass click handler down to AG Grid cell renderers via context
  const gridContext = {
    openImageDialog: (url) => handleOpenImage(url)
  };

  return (
    <div className='row'>
      <div className='col-md-6'><h4>Daily Work report</h4></div>
      <div className='col-md-6'>
        <DateSelect filter={filter} setFilter={setFilter} /> 
        <button className='btn btn-warning me-2 float-end' onClick={onBtnExport} ><Print /> Export </button>
      </div>
      <div className='col-md-12 mt-2'>
        <div className="ag-theme-alpine" style={{ height: 600 }}>
            <AgGridReact
              ref={gridRef}
              rowData={workReportList}
              columnDefs={columnDefs}
              defaultColDef={defaultColDef}
              rowHeight={210} 
              context={gridContext}
              animateRows={true}
              onGridReady={getWorkReport}
            />
          </div>
        </div>

      {/* Material UI Full Screen Image Dialog */}
      <Dialog
        fullScreen
        open={open}
        onClose={handleCloseImage}
        PaperProps={{
          style: {
            backgroundColor: 'rgba(0, 0, 0, 0.9)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          },
        }}
      >
        <IconButton
          edge="start"
          color="inherit"
          onClick={handleCloseImage}
          aria-label="close"
          style={{
            position: 'absolute',
            top: 20,
            right: 20,
            color: '#fff',
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
            zIndex: 1400,
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%' }}>
          {selectedImage && (
            <img
              src={selectedImage}
              alt="Full Size Report"
              style={{
                maxWidth: '100%',
                maxHeight: '100%',
                objectFit: 'contain',
              }}
            />
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default AllWorkReportList;